// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebaseConfig: {
    apiKey: 'AIzaSyAf6l7qoiXHWg1n4V0gqaWC-jXm4yvVkwA', //local AIzaSyCKHy-uhhXbITqXSteKv7lAKdAVbFwpPMY
    authDomain: 'qpathways-dev.firebaseapp.com',
    databaseURL: 'https://qpathways-dev.firebaseio.com',
    projectId: 'qpathways-dev',
    storageBucket: 'qpathways-dev.appspot.com',
    messagingSenderId: '413178660353',
    appId: '1:413178660353:web:6f8e21f6ecd9b665d4a200',
    measurementId: 'G-K21LBEKQLR',
    vapidKey:
      'BPnM0ilOA6PD4yKM7FtYFys9c3zLRw-OKyxQOmaC6aOtsShKGXKhSPqksihzlROOA8ByJ_t5DEZyPPSRIPmjC_E',
  },
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
